import { render } from "./LogoTile.vue?vue&type=template&id=4f876bcc&scoped=true&ts=true"
import script from "./LogoTile.vue?vue&type=script&lang=ts"
export * from "./LogoTile.vue?vue&type=script&lang=ts"

import "./LogoTile.vue?vue&type=style&index=0&id=4f876bcc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f876bcc"]])

export default __exports__